export default {
  policy: `
    <div>
      <p style="margin:0pt; orphans:0; text-align:center; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:16pt; font-weight:bold">
          Política de Privacidad del Sitio Web
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          La presente actualización de la Política de Privacidad entra en vigor el 1º de agosto de 2021. Si continúa utilizando AirClass después de esa fecha, significa que acepta nuestras condiciones de uso actualizadas.
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt; font-weight:bold">
          1. ¿Quién es el responsable del tratamiento de datos?
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          El responsable del tratamiento de datos es
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Air Class Limited, constituida en Inglaterra y Gales con el número de registro
        </span>
        <span style="background-color:#ffffff; color:#6f777b; font-family:'Times New Roman'; font-size:10.5pt">
          13536040 y con domicilio social en
        </span>
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          291 Brighton Road, South Croydon, Reino Unido, CR2 6EQ
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt; font-weight:bold">
          2. ¿Qué datos se procesan y de dónde proceden?
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Tratamos los datos personales que recibimos del usuario en el marco de nuestra relación comercial. Al hacerlo, nos regimos por el Reglamento General de Protección de Datos del Reino Unido (RGPD del Reino Unido). Asimismo, nos regimos por el Reglamento General de Protección de Datos de la UE (RGPD de la UE) en relación con los bienes y servicios que ofrecemos a las personas y a nuestras operaciones más amplias en el Espacio Económico Europeo (EEE).
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Recogemos sus datos personales:
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          De forma directa, cuando ingresa o nos envía información, por ejemplo, cuando se registra en nuestro sitio web, se pone en contacto con nosotros (incluso por correo electrónico), nos envía comentarios, adquiere servicios a través de nuestro sitio web, publica material en nuestro sitio web y cuando completa encuestas de clientes.
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Y, de forma indirecta, como por ejemplo cuando se navega por nuestro sitio web; recopilaremos información de forma indirecta utilizando "cookies", que se detallan a continuación:
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Los datos personales recogidos incluyen: 
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Tipo de institución educativa
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Curso escolar
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Número de teléfono
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Dirección de correo electrónico, en caso de que se haya proporcionado
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Preguntas que se formulan a la comunidad
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Respuestas enviadas a la comunidad
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Información de pago, en caso de que se haya proporcionado
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Foto de perfil, en caso de que se haya subido
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Datos de identificación del dispositivo en el que se ha instalado la app AirClass
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Sus respuestas a los temas particulares sobre su institución educativa, en caso de que se hayan publicado
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Descripción del perfil, en caso de que se haya proporcionado
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Información pertinente a la docencia (por ejemplo: fechas de exámenes, calificaciones, dificultades de aprendizaje, etc.), en caso de que se proporcione
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt; font-weight:bold">
          3. Cookies
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          En este sitio web se utilizan cookies para simplificar el uso del mismo y la comunicación, y para adaptar mejor a sus necesidades nuestra presencia en la web. Una cookie es un pequeño archivo de texto que un sitio web almacena en su disco duro. Las cookies no dañan su dispositivo y no contienen virus. Puede desactivar el uso de cookies en cualquier momento en la configuración de su navegador.
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt; font-weight:bold">
          4. Google Analytics
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          En este sitio web también utilizamos Google Analytics. Se trata de un servicio prestado por Google Inc, 1600 Amphitheatre Parkway, Mountain View, CA 94043, Estados Unidos ("Google"). Google utiliza "cookies", es decir, archivos de texto que se almacenan en su dispositivo y que permiten analizar el uso que usted hace de nuestras ofertas en línea. La información generada por las cookies sobre su uso de este sitio web (incluida su dirección IP) se transfiere a un servidor de Google en los Estados Unidos y se almacena allí. Google está registrado en el programa "EU-US Privacy Shield" del Departamento de Comercio de los Estados Unidos. Google utilizará esta información con el fin de evaluar su uso del sitio web, y creará informes sobre la actividad del sitio web para nosotros y para prestar otros servicios relacionados con la actividad del sitio web y el uso de Internet. Los terceros, incluido Google, utilizan las cookies almacenadas para publicar anuncios basados en las visitas anteriores de un usuario a nuestro sitio web. Google también puede transferir esta información a terceros cuando así lo exija la ley, o cuando dichos terceros realicen el tratamiento de la información en nombre de Google. Google no asociará su dirección IP con ningún otro dato que posea. Puede rechazar el uso de cookies seleccionando la configuración más adecuada en su navegador. Sin embargo, tenga en cuenta que si lo hace es posible que no pueda utilizar todas las funciones de este sitio web. Al utilizar este sitio web, usted acepta que Google procese los datos recopilados sobre usted de la manera descrita anteriormente y con la finalidad indicada. En cualquier momento podrá rechazar la recopilación y el almacenamiento de los datos, y el cambio se hará efectivo una vez que se haya realizado. El usuario puede desactivar el uso de cookies por parte de Google accediendo a la página de desactivación de la publicidad de Google (http://www.google.com/privacy_ads.html). Se puede también desactivar el uso de cookies por parte de terceros proveedores accediendo a la página de desactivación de la iniciativa publicitaria de la red. (http://www.networkadvertising.org/managing/opt_out.asp).
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt; font-weight:bold">
          5.¿Cómo utiliza AirClass la información recogida?
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt; font-weight:bold">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Podríamos utilizar la información que recopilamos, incluidos sus datos personales y los de sus hijos, en función de los diversos fines y del fundamento jurídico del tratamiento, como se indica a continuación:
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          5.1 Tratamos los siguientes datos personales con la finalidad y el fundamento jurídico de la ejecución del contrato, cumplimiento de productos y servicios:
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Nombre completo,
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Nombre de los niños,
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Edad de los niños,
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Género de los niños,
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Dirección de correo electrónico,
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Número de teléfono.
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Los datos personales obligatorios u opcionales que usted proporciona se utilizan con fines tales como el cumplimiento de las obligaciones definidas en el Acuerdo de Condiciones y Registro en Línea, la respuesta a sus preguntas, las solicitudes relacionadas con el servicio, la personalización del contenido visualizado, la comunicación con usted respecto a las ofertas de ventas relacionadas con los servicios especiales y las nuevas funciones, y la respuesta a los problemas relacionados con nuestros servicios.
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          5.2 Tratamos los siguientes datos personales en función del interés legítimo de AirClass (como base legal de este tratamiento) con fines de marketing y para el envío de correos electrónicos.
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Nombre completo,
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Número de teléfono,
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Cualquier otro dato personal proporcionado a los procesadores de datos de AirClass.
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Siempre que AirClass trata sus datos con fines de interés legítimo, siempre tiene presente los derechos de los usuarios sobre sus datos personales y los tiene en cuenta. Los usuarios siempre tienen derecho a oponerse a este tratamiento. Sin embargo, al hacerlo, se podría afectar la capacidad de AirClass para llevar a cabo las tareas mencionadas anteriormente en beneficio del usuario.
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          5.3 Tratamos los datos personales con el fin y el fundamento legal del
        </span>
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt; font-weight:bold">
          cumplimiento de las obligaciones legales
        </span>
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          para prevenir las operaciones fraudulentas, vigilar contra los robos y proteger de otro modo a nuestros clientes y nuestro negocio. También procesamos datos personales con el fin y el fundamento legal del 
        </span>
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt; font-weight:bold">
          cumplimiento de las leyes vigentes
        </span>
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          y para colaborar con los organismos encargados del cumplimiento de la ley y para dar respuesta a las citaciones judiciales.
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          5.4 Tratamos los siguientes datos personales con el propósito y el fundamento legal de nuestro interés legítimo de mejorar la eficacia del sitio web, nuestros servicios y los esfuerzos de marketing, para llevar a cabo investigaciones y análisis, incluidos grupos de discusión y encuestas, y para realizar otras actividades comerciales según sea necesario, o como se describe en otras partes del presente documento:
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Dirección IP,
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Información del navegador,
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Información de contacto,
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Contenido consumido en el sitio web,
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Contenido consumido en el sitio web,
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Características del navegador,
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Dominio y otras configuraciones del sistema,
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Consultas de búsqueda,
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Características del dispositivo,
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Tipo de sistema operativo,
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Preferencias de idioma,
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          URLs de referencia,
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Acciones realizadas en nuestro sitio web,
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Página solicitada,
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Contenido consumido (por ejemplo, visto, cargado y compartido),
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Fechas y horas de las visitas al sitio web,
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          El enlace desde el que ha sido redirigido a nuestro sitio web,
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Género,
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Rango de edad,
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          El tipo de navegador web utilizado,
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Acciones realizadas en la Aplicación,
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Fechas y horas de uso de la Aplicación,
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          El tiempo de permanencia en la Aplicación y la regularidad de sus visitas,
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Otra información de software y hardware,
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Otra información asociada a otros archivos almacenados en su dispositivo.
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Imágenes,
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Vídeo,
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Audio,
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Registro de errores,
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt; font-weight:bold">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          recibirá y registrará información sobre el dispositivo que está utilizando (número de IMEI, modelo del dispositivo, versión del sistema operativo, configuración del dispositivo, identificador único del dispositivo, características de hardware y software, información del dispositivo (IMEI/MAC/ID de Android/IDFA/OpenUDID /GUID/tarjeta SIM información IMSI, etc.)) e información sobre la ubicación del dispositivo (dirección IP, GPS y otra información del sensor) de acuerdo con los permisos específicos que haya otorgado durante la instalación y el uso del software.
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt; font-weight:bold">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Cuando sea posible, haremos anónimos los datos personales o utilizamos datos estadísticos no identificables. No recogemos datos personales por adelantado ni los almacenamos para posibles fines futuros, a menos que lo exija o lo permita la legislación aplicable.
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Para recopilar de forma anónima los datos mencionados y realizar estadísticas y análisis podemos utilizar los siguientes programas y software:
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <table cellspacing="0" cellpadding="0" style="border-collapse:collapse; margin-left:0pt; width:100%">
        <tr style="height:21.45pt">
          <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:1.5pt; border-left-color:#000000; border-left-style:solid; border-left-width:1.5pt; border-right-color:#000000; border-right-style:solid; border-right-width:1.5pt; border-top-color:#000000; border-top-style:solid; border-top-width:1.5pt; vertical-align:middle; width:28.96%">
            <p style="margin:0pt; orphans:0; text-align:center; widows:0">
              <span style="font-family:'Baskerville Old Face'; font-size:10.5pt; font-weight:bold">
                Nombre
              </span>
            </p>
          </td>
          <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:1.5pt; border-left-color:#000000; border-left-style:solid; border-left-width:1.5pt; border-right-color:#000000; border-right-style:solid; border-right-width:1.5pt; border-top-color:#000000; border-top-style:solid; border-top-width:1.5pt; vertical-align:middle; width:38.52%">
            <p style="margin:0pt; orphans:0; text-align:center; widows:0">
              <span style="font-family:'Baskerville Old Face'; font-size:10.5pt; font-weight:bold">
                Domicilio de la sede
              </span>
            </p>
          </td>
          <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:1.5pt; border-left-color:#000000; border-left-style:solid; border-left-width:1.5pt; border-right-color:#000000; border-right-style:solid; border-right-width:1.5pt; border-top-color:#000000; border-top-style:solid; border-top-width:1.5pt; vertical-align:middle; width:32.52%">
            <p style="margin:0pt; orphans:0; text-align:center; widows:0">
              <span style="font-family:'Baskerville Old Face'; font-size:10.5pt; font-weight:bold">
                País
              </span>
            </p>
          </td>
        </tr>
        <tr style="height:41.7pt">
          <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:1.5pt; border-left-color:#000000; border-left-style:solid; border-left-width:1.5pt; border-right-color:#000000; border-right-style:solid; border-right-width:1.5pt; border-top-color:#000000; border-top-style:solid; border-top-width:1.5pt; vertical-align:top; width:28.96%">
            <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
              <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
                Firebase
              </span>
            </p>
          </td>
          <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:1.5pt; border-left-color:#000000; border-left-style:solid; border-left-width:1.5pt; border-right-color:#000000; border-right-style:solid; border-right-width:1.5pt; border-top-color:#000000; border-top-style:solid; border-top-width:1.5pt; vertical-align:top; width:38.52%">
            <p style="margin:0pt; orphans:0; widows:0">
              <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
                1600 Amphitheatre Parkway Mountain View, CA 94043
              </span>
            </p>
          </td>
          <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:1.5pt; border-left-color:#000000; border-left-style:solid; border-left-width:1.5pt; border-right-color:#000000; border-right-style:solid; border-right-width:1.5pt; border-top-color:#000000; border-top-style:solid; border-top-width:1.5pt; vertical-align:top; width:32.52%">
            <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
              <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
                Estados Unidos de América
              </span>
            </p>
          </td>
        </tr>
        <tr style="height:28.45pt">
          <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:1.5pt; border-left-color:#000000; border-left-style:solid; border-left-width:1.5pt; border-right-color:#000000; border-right-style:solid; border-right-width:1.5pt; border-top-color:#000000; border-top-style:solid; border-top-width:1.5pt; vertical-align:top; width:28.96%">
            <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
              <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
                Jiyan
              </span>
            </p>
          </td>
          <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:1.5pt; border-left-color:#000000; border-left-style:solid; border-left-width:1.5pt; border-right-color:#000000; border-right-style:solid; border-right-width:1.5pt; border-top-color:#000000; border-top-style:solid; border-top-width:1.5pt; vertical-align:top; width:38.52%">
            <p style="margin:0pt; orphans:0; widows:0">
              <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
                8F, Building B3, Phase II, Wuda Airfield, East Lake New Technology Development Zone, Wuhan, China
              </span>
            </p>
          </td>
          <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:1.5pt; border-left-color:#000000; border-left-style:solid; border-left-width:1.5pt; border-right-color:#000000; border-right-style:solid; border-right-width:1.5pt; border-top-color:#000000; border-top-style:solid; border-top-width:1.5pt; vertical-align:top; width:32.52%">
            <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
              <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
                China
              </span>
            </p>
          </td>
        </tr>
        <tr style="height:40.45pt">
          <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:1.5pt; border-left-color:#000000; border-left-style:solid; border-left-width:1.5pt; border-right-color:#000000; border-right-style:solid; border-right-width:1.5pt; border-top-color:#000000; border-top-style:solid; border-top-width:1.5pt; vertical-align:top; width:28.96%">
            <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
              <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
                TalkingData
              </span>
            </p>
          </td>
          <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:1.5pt; border-left-color:#000000; border-left-style:solid; border-left-width:1.5pt; border-right-color:#000000; border-right-style:solid; border-right-width:1.5pt; border-top-color:#000000; border-top-style:solid; border-top-width:1.5pt; vertical-align:top; width:38.52%">
            <p style="margin:0pt; orphans:0; widows:0">
              <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
                Building 2, No.39 Dongzhimenwai Street, Dongcheng District, Beijing, China
              </span>
              <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
                China
              </span>
            </p>
          </td>
          <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:1.5pt; border-left-color:#000000; border-left-style:solid; border-left-width:1.5pt; border-right-color:#000000; border-right-style:solid; border-right-width:1.5pt; border-top-color:#000000; border-top-style:solid; border-top-width:1.5pt; vertical-align:top; width:32.52%">
            <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
              <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
                China
              </span>
            </p>
          </td>
        </tr>
        <tr style="height:41.7pt">
          <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:1.5pt; border-left-color:#000000; border-left-style:solid; border-left-width:1.5pt; border-right-color:#000000; border-right-style:solid; border-right-width:1.5pt; border-top-color:#000000; border-top-style:solid; border-top-width:1.5pt; vertical-align:top; width:28.96%">
            <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
              <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
                Youmeng
              </span>
            </p>
          </td>
          <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:1.5pt; border-left-color:#000000; border-left-style:solid; border-left-width:1.5pt; border-right-color:#000000; border-right-style:solid; border-right-width:1.5pt; border-top-color:#000000; border-top-style:solid; border-top-width:1.5pt; vertical-align:top; width:38.52%">
            <p style="margin:0pt; orphans:0; widows:0">
              <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
                Habitación 902, Edificio 9, Wangjing East Garden 4, Distrito de Chaoyang, Pekín, China
              </span>
            </p>
          </td>
          <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:1.5pt; border-left-color:#000000; border-left-style:solid; border-left-width:1.5pt; border-right-color:#000000; border-right-style:solid; border-right-width:1.5pt; border-top-color:#000000; border-top-style:solid; border-top-width:1.5pt; vertical-align:top; width:32.52%">
            <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
              <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
                China
              </span>
            </p>
          </td>
        </tr>
      </table>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          5.5 Integridad de los datos y limitación de los fines: AirClass solo recopilará y conservará los datos personales que sean pertinentes para los fines para los que se recopilan los datos, y no los utilizaremos de forma incompatible con dichos fines, a menos que dicho uso haya sido autorizado posteriormente por usted. Adoptaremos medidas razonables para garantizar que los datos personales sean fiables para el uso previsto, y que sean precisos, completos y actuales. Es posible que nos pongamos en contacto con usted de forma ocasional para determinar si sus datos siguen siendo precisos y están actualizados.
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt; font-weight:bold">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt; font-weight:bold">
          6. Factoraje
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          El proveedor/socio contractual es libre de utilizar sin restricciones los servicios de bancos de factoraje con sucursal en la Unión Europea (receptor de los datos).
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt; font-weight:bold">
          7. ¿Con qué fundamento legal y para qué fines se realiza el tratamiento de datos?
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Tratamos sus datos personales para cumplir nuestras obligaciones contractuales:
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          1) La coincidencia óptima entre el que pregunta y el que responde, para que el proceso se adapte mejor al cliente
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          2) Informar a los usuarios sobre las actualizaciones de la aplicación AirClass
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          3) Ofrecer tutorías en línea 
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          4) Procesar las solicitudes de asistencia al cliente para resolver disputas y problemas de servicio. También procesamos sus datos personales para cumplir con las obligaciones legales y para otros intereses legítimos (especialmente cookies, análisis web, uso con fines publicitarios como el envío de boletines), mientras no se anule su derecho a mantener la confidencialidad. 
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          - Para cumplir con las obligaciones contractuales
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Artículo 6 (1) b GDPR:
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          El tratamiento de datos personales se lleva a cabo para cumplir con nuestras obligaciones contractuales, en particular para cumplir con nuestros contratos con usted. La principal obligación contractual para la que tratamos los datos personales es el funcionamiento del servicio de aprendizaje que ofrecemos.
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          - Para cumplir con las exigencias legales
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Artículo 6 (1) c del GDPR:
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          El tratamiento de datos personales también se realiza con el fin de cumplir con diversas obligaciones legales a las que estamos sujetos. Un ejemplo de este tipo de tratamiento de datos basado en una obligación legal es el mantenimiento de una contabilidad adecuada.
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          - Para salvaguardar los intereses legítimos
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Artículo 6 (1) f GDPR):
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Tratamos los datos personales para proteger nuestros intereses legítimos, a menos que sus intereses de confidencialidad sean mayores que estos. 
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          En los siguientes casos, el tratamiento de datos se lleva a cabo para proteger intereses legítimos: publicidad y marketing, y mejora de nuestra oferta y de nuestro sitio web.
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Puede oponerse al tratamiento de datos personales sobre la base de intereses legítimos.
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt; font-weight:bold">
          8. ¿A quién se transmitirán sus datos?
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Podemos transmitir cierta información personal a terceros proveedores en el Reino Unido o en terceros países, que suministran aplicaciones de software, alojamiento web y otras tecnologías o servicios para el sitio web y nuestros servicios (en adelante: "Procesador de datos"). Solo proporcionaremos a estos terceros el acceso a la información que sea razonablemente necesaria para realizar su trabajo o cumplir con la ley. Dichos terceros nunca utilizarán dicha información para ningún otro fin que no sea el de prestar servicios en relación con el sitio web y nuestros servicios. Durante el servicio de tratamiento de datos, el Procesador de Datos se atendrá a la presente Política, a las legislaciones pertinentes en vigor, así como a las disposiciones de los contratos existentes entre él y AirClass. 
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Utilizamos el servicio de procesamiento de datos de los siguientes Procesadores de Datos:
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <table cellspacing="0" cellpadding="0" style="border-collapse:collapse; margin-left:0pt; width:100%">
        <tr style="height:36.45pt">
          <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:1.5pt; border-left-color:#000000; border-left-style:solid; border-left-width:1.5pt; border-right-color:#000000; border-right-style:solid; border-right-width:1.5pt; border-top-color:#000000; border-top-style:solid; border-top-width:1.5pt; vertical-align:middle; width:28.96%">
            <p style="margin:0pt; orphans:0; text-align:center; widows:0">
              <span style="font-family:'Baskerville Old Face'; font-size:10.5pt; font-weight:bold">
                Nombre
              </span>
            </p>
          </td>
          <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:1.5pt; border-left-color:#000000; border-left-style:solid; border-left-width:1.5pt; border-right-color:#000000; border-right-style:solid; border-right-width:1.5pt; border-top-color:#000000; border-top-style:solid; border-top-width:1.5pt; vertical-align:middle; width:24%">
            <p style="margin:0pt; orphans:0; text-align:center; widows:0">
              <span style="font-family:'Baskerville Old Face'; font-size:10.5pt; font-weight:bold">
                Domicilio de la sede
              </span>
            </p>
          </td>
          <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:1.5pt; border-left-color:#000000; border-left-style:solid; border-left-width:1.5pt; border-right-color:#000000; border-right-style:solid; border-right-width:1.5pt; border-top-color:#000000; border-top-style:solid; border-top-width:1.5pt; vertical-align:middle; width:17.14%">
            <p style="margin:0pt; orphans:0; text-align:center; widows:0">
              <span style="font-family:'Baskerville Old Face'; font-size:10.5pt; font-weight:bold">
                País
              </span>
            </p>
          </td>
          <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:1.5pt; border-left-color:#000000; border-left-style:solid; border-left-width:1.5pt; border-right-color:#000000; border-right-style:solid; border-right-width:1.5pt; border-top-color:#000000; border-top-style:solid; border-top-width:1.5pt; vertical-align:middle; width:29.9%">
            <p style="margin:0pt; orphans:0; text-align:center; widows:0">
              <span style="font-family:'Baskerville Old Face'; font-size:10.5pt; font-weight:bold">
                Actividad (servicio de procesamiento de datos)
              </span>
            </p>
          </td>
        </tr>
        <tr style="height:49.4pt">
          <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:1.5pt; border-left-color:#000000; border-left-style:solid; border-left-width:1.5pt; border-right-color:#000000; border-right-style:solid; border-right-width:1.5pt; border-top-color:#000000; border-top-style:solid; border-top-width:1.5pt; vertical-align:middle; width:28.96%">
            <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
              <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
                Alibaba Cloud Computing
              </span>
            </p>
          </td>
          <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:1.5pt; border-left-color:#000000; border-left-style:solid; border-left-width:1.5pt; border-right-color:#000000; border-right-style:solid; border-right-width:1.5pt; border-top-color:#000000; border-top-style:solid; border-top-width:1.5pt; vertical-align:middle; width:24%">
            <p style="margin:0pt; orphans:0; widows:0">
              <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
                No.12, Turnang Science and Technology Economic Block, Xihu District, Hangzhou, Zhejiang Province
              </span>
            </p>
          </td>
          <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:1.5pt; border-left-color:#000000; border-left-style:solid; border-left-width:1.5pt; border-right-color:#000000; border-right-style:solid; border-right-width:1.5pt; border-top-color:#000000; border-top-style:solid; border-top-width:1.5pt; vertical-align:middle; width:17.14%">
            <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
              <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
                China
              </span>
            </p>
          </td>
          <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:1.5pt; border-left-color:#000000; border-left-style:solid; border-left-width:1.5pt; border-right-color:#000000; border-right-style:solid; border-right-width:1.5pt; border-top-color:#000000; border-top-style:solid; border-top-width:1.5pt; vertical-align:middle; width:29.9%">
            <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
              <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
                Servicio de nube y servicio de servidor
              </span>
            </p>
          </td>
        </tr>
      </table>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Solo transferimos los datos personales recogidos de aquellas personas ubicadas en el Reino Unido con el consentimiento de estas a un tercero con domicilio fuera del Reino Unido que actúe como procesador de datos sin las garantías adecuadas establecidas en el GDPR, o cuando sea necesario para la ejecución del contrato. AirClass hará todo lo posible para garantizar que los datos personales se transfieran de forma segura y que los datos personales se procesen con arreglo al GDPR.
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          En caso de que exista una obligación legal, transmitimos los datos personales a organismos e instituciones públicas (por ejemplo, fuerzas de seguridad o tribunales).
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt; font-weight:bold">
          9. ¿Durante cuánto tiempo se procesan y almacenan sus datos?
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Solo procesamos sus datos personales si es necesario. Si usted retira su consentimiento, se eliminan automáticamente.
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Los datos personales necesarios para el cumplimiento del contrato se almacenan, en cualquier caso, durante toda la relación comercial e incluso luego de la misma, de acuerdo con las obligaciones legales de almacenamiento y documentación (por ejemplo, de acuerdo con la 
        </span>
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt; font-weight:bold">
          Ley de Protección de Datos 2018 de Reino Unido
        </span>
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          ). Además, tenemos en cuenta los plazos de prescripción legales, que pueden ser de hasta 30 años en determinados casos.
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt; font-weight:bold">
          10. ¿Qué derechos tiene usted?
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Derecho de acceso a la información:
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Si tratamos sus datos personales, tiene derecho a ser informado sobre los fines del tratamiento, las categorías de datos personales tratados, los destinatarios de dichos datos personales, el plazo de conservación, los derechos que le corresponden, el origen de los datos personales y la existencia de una toma de decisiones automatizada.
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="background-color:#ffffff; font-family:'Baskerville Old Face'; font-size:10.5pt">
          Usted nos concede una licencia libre de derechos y perpetua en todas nuestras aplicaciones para utilizar, copiar y reproducir el contenido y los materiales producidos por nosotros como resultado de la realización de las actividades de matrícula en línea. En cada caso con un crédito apropiado en relación con el respaldo de la matrícula, la investigación o la mejora de la calidad de AirClass y/o sus productos.
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Rectificación y supresión:
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Tiene derecho a solicitar la rectificación de los datos personales incorrectos o incompletos que le conciernen. Tiene derecho a solicitar la supresión de los datos personales que le conciernen si no existe ninguna obligación legal por nuestra parte de oponerse a la supresión, a menos que el tratamiento de los datos sea lícito.
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Restricción del tratamiento:
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          En determinados casos, tiene derecho a exigir que se restrinja el tratamiento de sus datos.
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Transferencia de datos:
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Tiene derecho a solicitar la transferencia de los datos que nos ha proporcionado en un formato estructurado, común y legible por máquina. Tiene derecho a solicitar que los datos personales sean transferidos directamente por nosotros a un responsable designado por usted, siempre que sea técnicamente posible.
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Discrepancia:
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Tiene derecho a oponerse en cualquier momento al tratamiento de los datos personales que le conciernen por motivos derivados de su situación. Si se opone, no seguiremos tratando los datos personales que le conciernen, a menos que podamos demostrar que nuestros motivos para el tratamiento superan sus intereses. Puede oponerse al uso de sus datos personales con fines publicitarios en cualquier momento; en este caso, dejaremos de procesar sus datos con fines publicitarios. Para ejercer sus derechos en relación con sus datos procesados por nosotros, póngase en contacto con nosotros a través de la siguiente dirección de correo electrónico: contact@air-class.com.
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt; font-weight:bold">
          11. Privacidad de los niños
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          No recogemos ni retenemos información personal de niños, excepto la necesaria para facilitar la tutoría de ese estudiante, que puede ser menor de edad.
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          AirClass se compromete a salvaguardar la información que cada usuario confía a AirClass y tiene la convicción de que cada usuario debería saber cómo se utiliza la información recogida. Aparte de la información y los materiales gratuitos que no requieren ningún registro o información de identificación, el Sitio no está dirigido a niños menores de 13 años, y AirClass no recopila a sabiendas información personal identificable de niños menores de 13 años que se encuentren en línea. Con el fin de utilizar el Sitio como plataforma para conectar con los tutores, los padres pueden proporcionar información como el nombre o la edad de sus hijos para que AirClass ayude a facilitar la conexión entre el estudiante y el tutor. AirClass puede almacenar esta información en un formato digital seguro. Los padres o tutores de los niños menores de 13 años pueden revisar o solicitar la eliminación de cualquier información personal proporcionada previamente por el niño, padre o tutor que finalmente sea recogida por AirClass, si usted desea revisar o eliminar dicha información, póngase en contacto con AirClass al número de teléfono o dirección de correo electrónico que se indica a continuación indicando lo que le gustaría hacer. AirClass se pondrá en contacto con usted para llevar a cabo la acción solicitada, que incluye, entre otras cosas, negarse a permitir la recopilación o el uso de más información.
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt; font-weight:bold">
          12. Reclamos
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt; font-weight:bold">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Tiene derecho a ponerse en contacto con:
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          Correo electrónico: contact@air-class.com
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          para presentar quejas, retirar su consentimiento u oponerse al uso de sus datos personales con fines publicitarios si considera que se han vulnerado sus derechos de protección de datos.
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
      <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:'Baskerville Old Face'; font-size:10.5pt">
          &#xa0;
        </span>
      </p>
    </div>
    <div class="cnzz" style="display: none;">
    </div>
  `,
  user: `
    <p style="margin-top:0pt; margin-bottom:0pt; text-align:center; widows:0; orphans:0; font-size:15pt">
      <span style="font-family:'Times New Roman'; font-weight:bold">
      Condiciones de prestación del servicio de educación en línea y Acuerdo de registro
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        El presente Acuerdo de registro en línea entrará en vigor el 1 de agosto de 2021.
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:12pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        Le damos la bienvenida al uso del servicio de educación en línea AirClass, por favor
      </span>
      <span style="font-family:'Times New Roman'; font-weight:bold">
        lea los siguientes términos y condiciones importantes antes de comprarnos cualquier contenido digital y compruebe que contienen todo lo que desea y nada que no esté dispuesto a aceptar.
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:36pt; margin-bottom:12pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        Por ley, el Reglamento de Contratos de Consumo (Información, Cancelación y Cargos Adicionales) de 2013 establece que debemos darle cierta información clave antes de que tenga lugar un contrato legalmente vinculante entre usted y nosotros.
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:21.25pt; margin-bottom:12pt; text-indent:-21.25pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'; font-weight:bold">
        1
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'; font-weight:bold">
        Primera parte de la información esencial: ‘¿Quiénes somos?’
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        1.1
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Somos Air Class Limited con el nombre comercial AirClass, una empresa registrada en Inglaterra y Gales con el número de empresa: 
      </span>
      <span style="font-family:'Times New Roman'; color:#6f777b; background-color:#ffffff">
        13536040.
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:54pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:54pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        1.2
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Nuestro domicilio social se ubica en: 291 Brighton Road, South Croydon, United Kingdom, CR2 6EQ
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        1.3
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Nuestro domicilio social se ubica en: 291 Brighton Road, South Croydon, United Kingdom, CR2 6EQ
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        1.4
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        AirClass sólo se utiliza como plataforma de educación y formación en línea.
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:21.25pt; margin-bottom:12pt; text-indent:-21.25pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'; font-weight:bold">
        2
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'; font-weight:bold">
        Primera parte de la información esencial: sus derechos legales
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        2.1
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        El Reglamento de Contratos de Consumo (Información, Cancelación y Cargos Adicionales) de 2013 establece que dispone del derecho a cambiar de opinión de 14 días y obtener un reembolso completo de su contenido digital. Perderá este derecho de cancelación una vez que inicie una descarga, siempre que se le haya informado de ello y lo haya aceptado.
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:54pt; margin-bottom:0pt; text-align:justify; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        2.2
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        La Ley de Derechos del Consumidor de 2015 dice que los contenidos digitales deben ser tal y como se describen, aptos para su uso y de calidad satisfactoria.
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        2.3
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Si su contenido digital es defectuoso, tiene derecho a una reparación o a una sustitución.
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        2.4
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Si el defecto no se puede subsanar, o si no se ha subsanado en un plazo razonable y sin inconvenientes significativos, puede recuperar una parte o la totalidad de su dinero.
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        2.5
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Si puede demostrar que el defecto ha dañado su dispositivo y que no hemos empleado un cuidado y una habilidad razonables, puede tener derecho a una reparación o a una indemnización.
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        2.6
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Este es un resumen de algunos de sus principales derechos. Para obtener información detallada de Citizens Advice, por favor visite
      </span>
      <span style="font-family:'Times New Roman'; color:#0000ff">
        www.citizensadvice.org.uk
      </span>
      <span style="font-family:'Times New Roman'">
        o llame al 0808 223 1133.
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-align:justify; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:21.25pt; margin-bottom:12pt; text-indent:-21.25pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'; font-weight:bold">
        3
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'; font-weight:bold">
        AirClass le recuerda que:
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        3.1
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Usted puede navegar por el contenido del sitio web o APP o páginas relacionadas por medio de enlaces, pero no puede obtener los servicios del curso AirClass sin registrar una cuenta. Después de su registro en la plataforma AirClass antes de que este acuerdo entre en vigor, puede acceder y/o utilizar el sitio web de la plataforma AirClass, el cliente (incluyendo las formas de APP/APK/SDK/API), la distribución de contenidos, la difusión de la red de información, etc.
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:54pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        3.2
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Al realizar cualquier acceso a los distintos formularios (incluyendo la aparición de nuevas formas de servicio en futuros desarrollos tecnológicos) se considera que acepta todo el contenido de este acuerdo, de lo contrario, por favor, no acceda o acepte los servicios de la plataforma AirClass.
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        3.3
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Nosotros no archivaremos los detalles de este contrato. Por favor, imprima o guarde una copia de este contrato para su archivo, ya que no guardaremos una copia por usted.
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        3.4
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Nosotros no archivaremos los detalles de este contrato. Por favor, imprima o guarde una copia de este contrato para su archivo, ya que no guardaremos una copia por usted.
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        3.5
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Usted debe ser una persona física con plena capacidad civil.
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        3.6
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        El registro del usuario se refiere al proceso mediante el cual se inicia la sesión en el sitio web oficial de AirClass, se rellena la información relevante que se requiere y se confirma que se acepta realizar el "Acuerdo".
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        3.7
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Usted será responsable del pago de todos los impuestos derivados de la transacción y de la obtención de los servicios pagados, así como de todos los gastos de hardware, software, servicios y otros.
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        3.8
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Todas las declaraciones, avisos, advertencias, etc. realizados por AirClass de diversas maneras (incluyendo, pero sin limitarse a, anuncios en la web, correos electrónicos, recordatorios por SMS, etc.) en relación con el uso de servicios específicos de la red AirClass se consideran parte de este "Acuerdo".
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-align:justify; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'; font-weight:bold">
        4
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'; font-weight:bold">
        Confirmación y aceptación de los términos del acuerdo de registro
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:12pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        En este acuerdo:
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        4.1
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        ‘
      </span>
      <span style="font-family:'Times New Roman'; font-weight:bold">
        nosotros
      </span>
      <span style="font-family:'Times New Roman'">
        ’, ‘
      </span>
      <span style="font-family:'Times New Roman'; font-weight:bold">
        a nosotros
      </span>
      <span style="font-family:'Times New Roman'">
        ’ o ‘
      </span>
      <span style="font-family:'Times New Roman'; font-weight:bold">
        nuestro
      </span>
      <span style="font-family:'Times New Roman'">
        ’
      </span>
      <span style="font-family:'Times New Roman'">
        significa "Air Class Limited"; y "AirClass", "este sitio Web".
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        4.2
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        ‘
      </span>
      <span style="font-family:'Times New Roman'; font-weight:bold">
        usted
      </span>
      <span style="font-family:'Times New Roman'">
        ’ o ‘
      </span>
      <span style="font-family:'Times New Roman'; font-weight:bold">
        su
      </span>
      <span style="font-family:'Times New Roman'">
        ’ significa "Usuario de AirClass", la persona que nos compra el servicio en línea.
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        4.3
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        AirClass se compromete a prestar servicios relacionados basados en Internet y en redes móviles (en lo sucesivo denominados "servicios de red") de conformidad con lo dispuesto en el presente acuerdo y en sus normas de funcionamiento publicadas periódicamente.
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        4.4
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Este acuerdo es el acuerdo de registro de usuario de AirClass ("Acuerdo"). Para recibir los servicios de formación en línea, deberá leer detenidamente y comprender en su totalidad los términos de este "Acuerdo", incluida la exención o limitación de la responsabilidad de AirClass.
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        4.5
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Por favor, lea atentamente y elija si acepta o no este "Acuerdo" (si usted es menor de edad, deberá leerlo con su tutor legal, y obtener el consentimiento y la orientación de sus padres o tutores antes de enviar información personal).
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        4.6
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Si decide aceptar todos los términos de este "Acuerdo", deberá completar todos los procedimientos de registro de acuerdo con las indicaciones de la página, y hacer clic en el botón "¡Solicitar ahora!" durante el proceso de 
        registro, de lo contrario se considerará que no acepta todos los términos de este "Acuerdo" y abandonará la solicitud.
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        4.7
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Una vez que se haya registrado correctamente en nuestro sitio web, AirClass le proporcionará una cuenta de usuario y la correspondiente contraseña. Deberá conservar cuidadosamente su cuenta y contraseña; será legalmente responsable de todas las actividades y eventos realizados con su cuenta. Si ha registrado la cuenta con éxito, AirClass llamará a cada usuario registrado y le presentará los servicios relacionados con la empresa.
      </span>
      <a name="_01546d83-c451-4329-9ac4-64e39ce5a367">
      </a>
      <a name="_6b45cc1e-3407-4e18-bd2e-20b71a1d3979">
      </a>
      <a name="_7bb648ae-fd4c-4ccd-98ad-b473ea5c1f7c">
      </a>
      <a name="_3187b50d-6418-4ddb-a5c1-f85f9118fe30">
      </a>
      <a name="_fe739c50-9d39-47a3-b9a9-c578f9d7dd7a">
      </a>
      <a name="_bc516f32-70f7-4095-8cd6-5b4704693a52">
      </a>
      <a name="_Toc256000003">
        <span style="-aw-bookmark-end:_01546d83-c451-4329-9ac4-64e39ce5a367">
        </span>
        <span style="-aw-bookmark-end:_6b45cc1e-3407-4e18-bd2e-20b71a1d3979">
        </span>
        <span style="-aw-bookmark-end:_7bb648ae-fd4c-4ccd-98ad-b473ea5c1f7c">
        </span>
        <span style="-aw-bookmark-end:_3187b50d-6418-4ddb-a5c1-f85f9118fe30">
        </span>
        <span style="-aw-bookmark-end:_fe739c50-9d39-47a3-b9a9-c578f9d7dd7a">
        </span>
        <span style="-aw-bookmark-end:_bc516f32-70f7-4095-8cd6-5b4704693a52">
        </span>
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'; font-weight:bold">
        5
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <a name="_217e867b-aeeb-4aec-99d8-c3c39726767f">
        <span style="-aw-bookmark-end:_Toc256000003">
        </span>
      </a>
      <span style="font-family:'Times New Roman'; font-weight:bold">
        Exponemos cómo se realiza un contrato legalmente vinculante entre usted y nosotros.
      </span>
      <a name="_ac3b9de9-1e2e-4a11-aec4-4d2a025fcea2">
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        5.1
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Usted realiza un pedido en el sitio web a través de [introduzca los datos]. Le rogamos que lea y compruebe cuidadosamente su pedido antes de enviarlo. Podrá corregir cualquier error antes de enviarnos su pedido.
      </span>
      <a name="_f989596b-6e42-4e9c-9cfe-ef89c5c6b20e">
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        5.2
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Antes de realizar su pedido, debe comprobar que los requisitos de hardware y software de su ordenador o dispositivo le permiten descargar el contenido digital. Si desea ver los requisitos, haga clic en el botón "Información técnica esencial".
      </span>
      <a name="_1612973249-55567178">
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        5.3
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Cuando realice su pedido al final del proceso de compra en línea (por ejemplo, cuando haga clic en el botón [introduzca datos como "pagar ahora"]), le enviaremos un acuse de recibo por correo electrónico. Sin embargo, este acuse de recibo no significa que su pedido haya sido aceptado por nosotros.
      </span>
      <a name="_1582889131-44326825">
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        5.4
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Es posible que nos pongamos en contacto con usted para decirle que no aceptamos su pedido. Esto suele ser por las siguientes razones:
      </span>
      <a name="_1582889131-430211425">
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        5.4.1
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        el contenido digital no está disponible;
      </span>
      <a name="_1582889131-453531325">
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        5.4.2
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        no podemos autorizar su pago;
      </span>
      <a name="_1582889131-47389325">
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        5.4.3
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        no podemos autorizar su pago;
      </span>
      <a name="_1582889131-450761225">
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        5.4.4
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        no estamos autorizados a venderle el contenido digital a usted; o
      </span>
      <a name="_1582889131-38660225">
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:35.45pt; margin-bottom:0pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        5.4.5
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        ha habido un error en el precio o la descripción del contenido digital.
      </span>
      <a name="_1582889131-44591425">
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        5.5
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Sólo habremos aceptado su pedido cuando le enviemos un correo electrónico para confirmarlo (
      </span>
      <span style="font-family:'Times New Roman'; font-weight:bold">
        email de confirmación
      </span>
      <span style="font-family:'Times New Roman'">
        ). En ese momento:
      </span>
      <a name="_1582889131-476321125">
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        5.5.1
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        existirá un contrato legalmente vinculante entre usted y nosotros; y
      </span>
      <a name="_1582889131-47398425">
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        5.5.2
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        el contenido digital se descargará automáticamente.
      </span>
      <a name="_1582889131-47911225">
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:114pt; margin-bottom:0pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        5.6
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Si usted es menor de 18 años no puede comprar ningún contenido digital del sitio a menos que esté supervisado por su representante legal.
      </span>
      <a name="_f1225865-e21d-4403-a59e-80af55bce383">
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        5.7
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Al comprar cualquier servicio en línea en nuestro sitio, también acepta estar legalmente vinculado a:
      </span>
      <a name="_6bc538d8-fc75-49b1-96ef-802cc212a230">
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        5.7.1
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        los términos y condiciones de nuestro sitio web [y cualquier documento al que se haga referencia en ellos];
      </span>
      <a name="_a8ea1ffc-4ac8-4e22-9da6-7518d0edb8ee">
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        5.7.2
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        aceptar los servicios telefónicos adicionales de la empresa.
      </span>
      <a name="_52de8084-9f38-4d08-9e81-79d95ccf8487">
      </a>
      <a name="_cf270abe-4ee0-40f0-a940-e1016f966d3e">
      </a>
      <a name="_7c947a75-0149-4570-93ab-7b082e88f4de">
        <span style="-aw-bookmark-end:_52de8084-9f38-4d08-9e81-79d95ccf8487">
        </span>
        <span style="-aw-bookmark-end:_cf270abe-4ee0-40f0-a940-e1016f966d3e">
        </span>
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        5.8
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Si continúa utilizando estos servicios de la red AirClass, se considera que acepta el contenido de dichas declaraciones, avisos y advertencias.
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        AirClass publicará un anuncio en el sitio web para notificarle los cambios del acuerdo y tendrá un efecto automático e inmediato. Si no acepta las condiciones modificadas, le rogamos que deje de utilizar inmediatamente los servicios de red prestados por este sitio web; de lo contrario, se considerará que ha aceptado el acuerdo modificado.
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'; font-weight:bold">
        6
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'; font-weight:bold">
        Derechos y obligaciones de AirClass
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        6.1
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Cuando AirClass suministra los contenidos digitales:
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        6.1.1
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        AirClass mantendrá una operación de calidad basada en la tecnología actual, y utilizará todos los esfuerzos razonables para garantizar que esté libre de defectos, virus y otros contenidos maliciosos.
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        6.1.2
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        no prometemos que sea compatible con ningún software o equipo de terceros, excepto cuando hayamos dicho que lo es en la guía de uso o en nuestro sitio; y no nos responsabilizamos de la interrupción o suspensión de los servicios por causas de fuerza mayor u otros factores no humanos.
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        6.1.3
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Usted acepta que puede haber pequeños errores o fallos en el mismo.
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        6.1.4
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Los contenidos digitales que le proporcionamos deben ser como se describen, adecuados a su finalidad y de calidad satisfactoria.
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        6.2
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        AirClass responderá eficazmente a los problemas relativos a la transacción o al registro que haya encontrado durante el registro y el uso de la plataforma de formación en línea AirClass;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        6.3
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        AirClass responderá eficazmente a los problemas relativos a la transacción o al registro que haya encontrado durante el registro y el uso de la plataforma de formación en línea AirClass;
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        6.4
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        AirClass tiene tolerancia cero con el comportamiento inadecuado en la plataforma educativa de la red AirClass o en cualquier otra situación. AirClass o quien AirClass autorice, tiene derecho a exigirle que reduzca el impacto de su comportamiento inadecuado, incluyendo, pero sin limitarse, a cambiar o eliminar el contenido publicado por usted, y a suspender o cancelar su derecho a utilizar el servicio de red sin su consentimiento;
      </span>
      <span style="font-family:'Times New Roman'">
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        6.5
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        AirClass se reserva el derecho de supervisar y guiar sus actividades en línea, y tiene el derecho de poner fin a todos sus servicios si usted participa en actividades ilegales en línea.
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        6.6
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        AirClass tiene derecho a revisar y supervisar el uso que usted hace de los servicios de la red AirClass, incluyendo, pero sin limitarse a ello, la revisión del contenido almacenado por usted en AirClass.
      </span>
      <a name="_Toc256000007">
      </a>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        6.7
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        AirClass tiene derecho a recibir pagos de usted por el servicio prestado:
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        6.7.1
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Aceptamos las siguientes tarjetas de crédito y el pago en línea como el Alipay o el pago de Wechat. No aceptamos dinero en efectivo o cheques.
      </span>
      <a name="_155bffb7-9b2d-42ca-ba30-bfff464a3018">
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        6.7.2
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Haremos todo lo razonablemente posible para garantizar que toda la información que nos proporcione al pagar por el contenido digital sea segura, utilizando un mecanismo de pago seguro encriptado. No obstante, en ausencia de negligencia por nuestra parte, de cualquier incumplimiento de este contrato o de nuestra Política de Privacidad o de la violación por nuestra parte de nuestras obligaciones en virtud de la legislación aplicable, no seremos legalmente responsables ante usted de cualquier pérdida que pueda sufrir si un tercero obtiene acceso no autorizado a cualquier información que nos facilite.
      </span>
      <a name="_91cdb4f6-fad1-422b-ad31-5bc2ed75b04e">
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        6.7.3
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        El cargo en su tarjeta de crédito o en el pago en línea sólo se realizará una vez que se le haya enviado el correo electrónico de confirmación, momento en el que se iniciará automáticamente la descarga del contenido digital.
      </span>
      <a name="_5a5e86a4-2831-46f4-9455-19dbc7f6282c">
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        6.7.4
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Todos los pagos con tarjeta de crédito o en línea deben ser autorizados por el emisor de la tarjeta correspondiente. También es posible que tengamos que utilizar medidas de seguridad adicionales a través de un código verificado:
      </span>
      <a name="_9ebd2859-680b-4e60-b7a1-2fb8ce7a532b">
      </a>
      <a name="_b86491e1-9687-4405-be67-d334bf4dfda2">
      </a>
      <a name="_e2c206d2-5e94-446f-a35c-a6f3c38ce9a5">
        <span style="-aw-bookmark-end:_9ebd2859-680b-4e60-b7a1-2fb8ce7a532b">
        </span>
        <span style="-aw-bookmark-end:_b86491e1-9687-4405-be67-d334bf4dfda2">
        </span>
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        6.7.5
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Todos los precios se expresan en libras esterlinas (£)(GBP) e incluyen VAT.
      </span>
      <a name="_1b6fcc59-6fbd-43da-9db0-9abe105b4d66">
      </a>
      <a name="_179004c4-3339-4682-a3db-674982ecedad">
      </a>
      <a name="_12032f91-796b-4d2b-8ec0-a2623d6eecc4">
      </a>
      <a name="_7bbb4d32-a37f-42db-811e-c59c67778358">
      </a>
      <a name="_3d783f9a-0c92-4d01-b345-9ca7ba102875">
      </a>
      <a name="_Toc256000009">
        <span style="-aw-bookmark-end:_1b6fcc59-6fbd-43da-9db0-9abe105b4d66">
        </span>
        <span style="-aw-bookmark-end:_179004c4-3339-4682-a3db-674982ecedad">
        </span>
        <span style="-aw-bookmark-end:_12032f91-796b-4d2b-8ec0-a2623d6eecc4">
        </span>
        <span style="-aw-bookmark-end:_7bbb4d32-a37f-42db-811e-c59c67778358">
        </span>
        <span style="-aw-bookmark-end:_3d783f9a-0c92-4d01-b345-9ca7ba102875">
        </span>
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        6.8
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Contenidos digitales defectuosos
      </span>
      <a name="_2e32de91-d379-4467-8abc-5c175ff3e929">
        <span style="-aw-bookmark-end:_Toc256000009">
        </span>
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        6.8.1
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        En la parte superior de esta página se exponen los derechos que le otorga la Ley de Derechos del Consumidor de 2015 (también conocidos como "derechos legales"). Se trata de un resumen de algunos de sus principales derechos. Para obtener información más detallada sobre sus derechos y lo que debe esperar de nosotros, visite el sitio web de Citizens Advice www.citizensadvice.org.uk o llame al 0808 223 1133.
      </span>
      <a name="_287e90bd-f85f-4367-b8d7-3aa233c8bab8">
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        6.8.2
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <a name="_9f12bda9-2c3b-428a-bfde-e8194e992bf7">
      </a>
      <span style="font-family:'Times New Roman'">
        Si su contenido digital resulta defectuoso, póngase en contacto con nosotros a través de los datos de contacto que aparecen en la parte superior de esta página.
      </span>
      <a name="_1fdf4a08-19eb-4ab7-be64-5bd182d77fa6">
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        6.8.3
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Para evitar fallos en los contenidos digitales, hay que:
      </span>
      <a name="_6e1919df-875b-4043-bd93-75b66b2800cb">
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-indent:-21pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:Wingdings">
        
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        instalar todas las correcciones, actualizaciones, nuevos lanzamientos y nuevas versiones tan pronto como sea razonablemente posible después de que le indiquemos que están disponibles para su descarga; y
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:20pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-indent:-21pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:Wingdings">
        
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        utilizarlos sólo en los programas y equipos de terceros recomendados en la guía de uso o en nuestro sitio.
      </span>
      <a name="_4586fadb-fc13-43ac-9eb5-ccae9277f9ab">
      </a>
      <a name="_57bf4eb4-ce38-47a8-9d38-6622a3bb5de5">
        <span style="-aw-bookmark-end:_4586fadb-fc13-43ac-9eb5-ccae9277f9ab">
        </span>
      </a>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'; font-weight:bold">
        7
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'; font-weight:bold">
        Derechos y obligaciones del usuario
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        7.1
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        La Ley de Derechos del Consumidor de 2015 le otorga ciertos "derechos legales"); y
      </span>
      <span style="font-family:'Times New Roman'">
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        7.2
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        El permiso para utilizar el contenido digital
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:18pt; margin-bottom:0pt; text-align:justify; font-size:12pt">
      <span style="width:18pt; display:inline-block; -aw-tabstop-align:left; -aw-tabstop-pos:36pt">
        &nbsp;
      </span>
      <span style="width:6pt; display:inline-block">
        &nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Cuando adquiera el contenido digital y lo descargue, no será su propietario. En cambio, le daremos permiso para utilizarlo con el fin de que lo use y disfrute de acuerdo con este acuerdo.
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:18pt; margin-bottom:0pt; text-align:justify; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        7.3
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        El contenido digital
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        7.3.1
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        es personal para usted. Puede utilizarlo en cualquier parte del mundo, pero sólo si cumples con las leyes locales;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        7.3.2
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        no es exclusivo para usted. Podemos suministrar el mismo contenido digital o uno similar a otros usuarios;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        7.3.3
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        sólo puede utilizarse en [introduzca número] ordenador[es] o dispositivo[s];
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:108pt; margin-bottom:0pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        7.4
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Usted no puede:
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:3pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        7.4.1
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        copiarlo salvo por un número razonable de copias de seguridad.
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:3pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        7.4.2
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        modificado por usted, lo que significa que no se le permite adaptarlo, realizar ingeniería inversa o descompilarlo, ni intentar extraer el código fuente de la misma, excepto cuando todo ello esté permitido por la ley;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:3pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        7.4.3
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        combinado o fusionado con cualquier otro programa informático, o utilizados en él; o
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:99.2pt; margin-bottom:3pt; text-indent:-35.4pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        7.4.3.1
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        distribuirlo o venderlo directamente, por usted o mediante cualquier tipo de tercero;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        7.4.4
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        contiene información que nos pertenece a nosotros y/o a terceros. No debe ocultar, cambiar o eliminar ninguna marca que muestre quién es el propietario de esta información, como los derechos de autor (©), las marcas registradas (®) o las marcas no registradas (™).
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        7.4.5
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Salvo en el caso de que tenga permiso para utilizar el contenido digital en virtud de esta cláusula, no obtendrá ningún derecho de propiedad u otros derechos (de cualquier naturaleza) sobre el contenido digital o sobre cualquier copia del mismo.
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        7.5
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Usted debe cumplir con lo siguiente:
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        7.5.1
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        cumplir con todos los protocolos, normas, procedimientos y prácticas de la red para utilizar nuestros servicios;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        7.5.2
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        no utilizar la plataforma de formación en línea AirClass para cualquier propósito o actividad ilegal;
      </span>
      <span style="font-family:'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        7.5.3
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        no interferir en el uso y funcionamiento de AirClass y no infringir los derechos normales de otros usuarios;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        7.5.4
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        no permitir que un tercero acceda a su cuenta, ya sea con o sin dinero, o con otros fines;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        7.5.5
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        ser tolerante con la transferencia técnica entre China y el extranjero, y cumplir con las leyes y reglamentos pertinentes
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        7.5.6
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        actualizar su información de registro a tiempo para garantizar que su información personal es detallada y precisa cuando su información de registro personal cambie.
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        7.5.7
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        proporcionar un nombre de usuario y una contraseña exactos, así como información de contacto, de acuerdo con las instrucciones de registro; toda la información proporcionada por usted se considerará exacta y válida.
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        7.5.8
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        permitir que el personal de AirClass se ponga en contacto con usted para el uso de su educación en línea;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:22.5pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        7.6
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        En caso de incumplimiento de las disposiciones de la cláusula 6, AirClass se reserva la facultad de cerrar inmediatamente su cuenta. Además, usted será responsable de las consecuencias del incumplimiento en la plataforma educativa de AirClass.
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:54pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        7.7
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Equiparse para la formación en línea, como PC, módems u otros dispositivos de Internet necesarios;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        7.7.1
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Asumir los costes por el uso de esta plataforma de formación en línea, como la cuota de teléfono e Internet, la cuota de información de Internet y la cuota de información educativa, etc. Su nombre de usuario y contraseña.
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        7.7.2
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Usted será plenamente responsable de la seguridad de su nombre de usuario (también conocido como número de cuenta) y contraseña;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        7.7.3
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Usted deberá notificarnos inmediatamente, si descubre cualquier uso ilegal de su cuenta, AirClass no le eximirá de responsabilidad por el uso de cuentas y contraseñas por parte de un tercero, incluso si se produce por piratería informática o por su negligencia.
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:36pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'; font-weight:bold">
        8
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <a name="_10e82c4e-53a3-4613-a3c4-b6d76004f086">
      </a>
      <a name="_ced346bf-9c1c-465a-8b87-7026832647bd">
      </a>
      <a name="_340f1983-5428-4b25-a40e-5e042a9ba962">
      </a>
      <a name="_ccb63846-4c94-4f2f-a9b0-3d0d19f181c1">
      </a>
      <a name="_0393d9d9-2319-4876-a820-1734ab5f095b">
      </a>
      <a name="_c2d8dbf6-09d2-4266-a47e-aeaa1e6911a6">
      </a>
      <a name="_4a557e3a-0d99-471b-891a-21ab7fa55244">
      </a>
      <a name="_f6f97d58-04c4-4c4c-b526-56691fed11a6">
      </a>
      <a name="_5b61a348-e779-4f86-b8fb-bf7ad3b8dff4">
      </a>
      <a name="_ac376d3f-1d15-4bb5-9a6d-22e9bd88f44a">
      </a>
      <a name="_469fd56d-b3ad-4047-8dd4-1ac64cb94446">
      </a>
      <a name="_1ec32b0d-940d-467f-8a2e-81b1aef0e73c">
      </a>
      <a name="_7f9333e6-17b2-4466-8415-792cc170bf32">
      </a>
      <a name="_e9588e74-9dc0-48d9-9ba1-b5dea9614e6b">
      </a>
      <a name="_17fdbac2-0aed-4e19-8886-e48403d817cc">
      </a>
      <a name="_830524f4-9385-43ec-83c4-768f7eabbdca">
      </a>
      <a name="_884718f9-d781-40d8-99a5-8a1ff6e4a589">
      </a>
      <a name="_050fbd09-8e82-45ca-8f52-e9502270b6b9">
      </a>
      <a name="_00a9c1dd-7109-4766-a930-ffe05f22a7b6">
      </a>
      <a name="_Toc256000006">
        <span style="-aw-bookmark-end:_10e82c4e-53a3-4613-a3c4-b6d76004f086">
        </span>
        <span style="-aw-bookmark-end:_ced346bf-9c1c-465a-8b87-7026832647bd">
        </span>
        <span style="-aw-bookmark-end:_340f1983-5428-4b25-a40e-5e042a9ba962">
        </span>
        <span style="-aw-bookmark-end:_ccb63846-4c94-4f2f-a9b0-3d0d19f181c1">
        </span>
        <span style="-aw-bookmark-end:_0393d9d9-2319-4876-a820-1734ab5f095b">
        </span>
        <span style="-aw-bookmark-end:_c2d8dbf6-09d2-4266-a47e-aeaa1e6911a6">
        </span>
        <span style="-aw-bookmark-end:_4a557e3a-0d99-471b-891a-21ab7fa55244">
        </span>
        <span style="-aw-bookmark-end:_f6f97d58-04c4-4c4c-b526-56691fed11a6">
        </span>
        <span style="-aw-bookmark-end:_5b61a348-e779-4f86-b8fb-bf7ad3b8dff4">
        </span>
        <span style="-aw-bookmark-end:_ac376d3f-1d15-4bb5-9a6d-22e9bd88f44a">
        </span>
        <span style="-aw-bookmark-end:_469fd56d-b3ad-4047-8dd4-1ac64cb94446">
        </span>
        <span style="-aw-bookmark-end:_1ec32b0d-940d-467f-8a2e-81b1aef0e73c">
        </span>
        <span style="-aw-bookmark-end:_7f9333e6-17b2-4466-8415-792cc170bf32">
        </span>
        <span style="-aw-bookmark-end:_e9588e74-9dc0-48d9-9ba1-b5dea9614e6b">
        </span>
        <span style="-aw-bookmark-end:_17fdbac2-0aed-4e19-8886-e48403d817cc">
        </span>
        <span style="-aw-bookmark-end:_830524f4-9385-43ec-83c4-768f7eabbdca">
        </span>
        <span style="-aw-bookmark-end:_884718f9-d781-40d8-99a5-8a1ff6e4a589">
        </span>
        <span style="-aw-bookmark-end:_050fbd09-8e82-45ca-8f52-e9502270b6b9">
        </span>
        <span style="-aw-bookmark-end:_00a9c1dd-7109-4766-a930-ffe05f22a7b6">
        </span>
        <span style="font-family:'Times New Roman'; font-weight:bold">
          Descarga
        </span>
      </a>
      <a name="_8c4fc406-e0b6-428a-bd38-822d50b3a1f1">
        <span style="-aw-bookmark-end:_Toc256000006">
        </span>
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        8.1
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Una vez que haya realizado su pedido y se le haya enviado el correo electrónico de confirmación, el contenido digital se descargará automáticamente.
      </span>
      <a name="_8ccac44e-3f0d-4919-8a40-47aa216441b4">
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        8.2
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Podemos entregar su contenido digital a plazos.
      </span>
      <a name="_02db3a43-fab6-40c8-99f5-54605b840411">
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        8.3
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Si ocurre algo que está fuera de nuestro control y afecta a su capacidad para descargar el contenido digital, le haremos saber cuánto puede esperar poder descargar el contenido digital.
      </span>
      <a name="_765bc153-bf52-4cef-89d1-26298fbac3c3">
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        8.4
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Si su ordenador o dispositivo bloquean la descarga automática de los contenidos digitales o la descarga automática no se inicia, aún puede tener derecho a cancelar el contrato. Si esto ocurre, póngase en contacto con nosotros utilizando los datos de contacto que aparecen al final de este contrato.
      </span>
      <a name="_1582891063-42793125">
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'; font-weight:bold">
        9
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <a name="_f5ca0fc2-55ab-43ca-a63d-96c17dcf9302">
      </a>
      <a name="_Toc256000011">
        <span style="-aw-bookmark-end:_f5ca0fc2-55ab-43ca-a63d-96c17dcf9302">
        </span>
        <span style="font-family:'Times New Roman'; font-weight:bold">
          Limitación de nuestra responsabilidad
        </span>
      </a>
      <a name="_58febe85-b527-4522-8099-3573c2339390">
        <span style="-aw-bookmark-end:_Toc256000011">
        </span>
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        9.1
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Salvo en el caso de cualquier responsabilidad legal que no podamos excluir por ley (como, por ejemplo, por muerte o lesiones a las personas) o que surja de las leyes aplicables relativas a la protección de su información personal, no somos legalmente responsables de ninguna:
      </span>
      <a name="_76321a1f-68b1-427a-9d90-96e3bcb27e21">
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        9.1.1
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        pérdida que no le fuera previsible cuando se formó dicha pérdida;
      </span>
      <a name="_32541001-d49f-40f2-a243-913ae09426db">
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        9.1.2
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        pérdidas que no fueran causadas por ninguna brecha por nuestra parte;
      </span>
      <a name="_1613496475-66854125">
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        9.1.3
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        pérdidas de negocio; o
      </span>
      <a name="_eec9a248-9840-447b-a406-723230e0a482">
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        9.1.4
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        pérdidas de los no clientes.
      </span>
      <a name="_1c1036de-ed35-407c-93e3-a3ad70e93070">
      </a>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'; font-weight:bold">
        10
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <a name="_Toc256000002">
        <span style="font-family:'Times New Roman'; font-weight:bold">
          Su privacidad e información personal
        </span>
      </a>
      <a name="_1518623016-402301527">
        <span style="-aw-bookmark-end:_Toc256000002">
        </span>
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        10.1
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Nuestra Política de Privacidad está disponible en [introduzca la dirección Web].
      </span>
      <a name="_1518626009-47106527">
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        10.2
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Su privacidad y su información personal son importantes para nosotros. Cualquier información personal que nos proporcione será tratada de acuerdo con nuestra Política de Privacidad,
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        10.3
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Podríamos ponernos en contacto con usted con la información que recogemos de usted, si tenemos una consulta o preocupación sobre el uso de su cuenta.
      </span>
      <a name="_1518626008-39725427">
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'; font-weight:bold">
        11
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <a name="_Toc256000012">
        <span style="font-family:'Times New Roman'; font-weight:bold">
          Derechos de terceros
        </span>
      </a>
      <a name="_409e7914-daa5-4e8a-9886-bf2eaedfa87f">
        <span style="-aw-bookmark-end:_Toc256000012">
        </span>
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:36pt; margin-bottom:12pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        Nadie que no sea una de las partes de este contrato tiene derecho a hacer cumplir cualquier término de este contrato.
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'; font-weight:bold">
        12
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <a name="_Toc256000013">
        <span style="font-family:'Times New Roman'; font-weight:bold">
          Disputas
        </span>
      </a>
      <a name="_62ea0121-7d55-4c7d-b754-53d31eafaf51">
        <span style="-aw-bookmark-end:_Toc256000013">
        </span>
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        12.1
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'">
        Intentaremos resolver cualquier conflicto con usted de forma rápida y eficaz. Si no está satisfecho con el contenido digital que ha comprado, con el servicio que le hemos prestado o con cualquier otro asunto, por favor, póngase en contacto con nosotros lo antes posible utilizando los datos de contacto que figuran en la parte superior de esta página.
      </span>
      <a name="_e83d84fb-def1-4ea9-bca5-6e51799ff2ba">
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        12.2
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <a name="_1617096359-40449625">
      </a>
      <span style="font-family:'Times New Roman'">
        Si no es posible resolver una disputa de acuerdo con nuestra Política de Tramitación de Reclamaciones o está descontento con el resultado, puede recurrir a la resolución alternativa de conflictos (
      </span>
      <span style="font-family:'Times New Roman'; font-weight:bold">
        RAL
      </span>
      <span style="font-family:'Times New Roman'">
        ).
      </span>
      <a name="_9f4a86dc-2c74-4507-8dfa-df12cd7e1a25">
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        12.3
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <a name="_57100ea7-c4a7-4979-a1ab-0bf6c38645ac">
      </a>
      <span style="font-family:'Times New Roman'">
        Si no desea recurrir a la RAL o no está satisfecho con el resultado de la misma, puede iniciar un procedimiento judicial.
      </span>
      <a name="_1613496889-53256825">
      </a>
    </p>
    <p style="margin-top:0pt; margin-left:49.6pt; margin-bottom:12pt; text-indent:-28.35pt; text-align:justify; line-height:115%; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        12.4
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <a name="_1629821316-491662136">
      </a>
      <span style="font-family:'Times New Roman'">
        Cualquier disputa estará sujeta a la jurisdicción no exclusiva de los tribunales de Inglaterra y Gales. Esto significa que puede elegir entre presentar una reclamación ante los tribunales de Inglaterra y Gales o ante los tribunales de otra parte del Reino Unido en la que resida.
      </span>
      <a name="_f6cca254-e538-475b-a71d-15fa52f3ec14">
      </a>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'; font-weight:bold">
        13
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'; font-weight:bold">
        Jurisdicción Legal
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        Las leyes de la República Popular China y el tribunal correspondiente de la República Popular China se aplican a la celebración, ejecución, interpretación y resolución de conflictos de este acuerdo, aunque si usted es residente en otro país, conservará el beneficio de cualquier protección obligatoria que le otorguen las leyes de ese país.
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'; font-weight:bold">
        14
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'; font-weight:bold">
        Propiedad Intelectual
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        AirClass posee todos los derechos de propiedad intelectual de los contenidos de AirClass suministrados en la plataforma. Sin nuestro permiso, nadie tiene derecho a copiar, difundir o infringir ninguno de los derechos de propiedad intelectual de AirClass.
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'; font-weight:bold">
        15
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'; font-weight:bold">
        Aviso de Copyright
      </span>
    </p>
    <p style="margin-top:0pt; margin-right:9.75pt; margin-bottom:0pt; line-height:14.65pt; background-color:#ffffff">
      <span style="font-family:'Times New Roman'; font-size:12pt">
        AirClass es el propietario o licenciatario ("titular de los derechos") de todos los derechos de propiedad intelectual relacionados con esta plataforma en línea y sus contenidos, incluidos, entre otros, los derechos de autor, los nombres comerciales y de marca, las marcas comerciales, los productos y la presentación. Si AirClass no autoriza el uso de cualquiera de ellos, dicho uso puede constituir una infracción de los derechos del titular.
      </span>
    </p>
    <p style="margin-top:0pt; margin-right:9.75pt; margin-bottom:0pt; line-height:14.65pt; background-color:#ffffff">
      <a name="ORIGHIT_11">
      </a>
      <a name="HIT_11">
      </a>
      <a name="ORIGHIT_12">
      </a>
      <a name="HIT_12">
        <span style="-aw-bookmark-end:ORIGHIT_11">
        </span>
        <span style="-aw-bookmark-end:HIT_11">
        </span>
        <span style="-aw-bookmark-end:ORIGHIT_12">
        </span>
      </a>
      <span style="font-family:'Times New Roman'; font-size:12pt; color:#39393a">
        El permiso para reproducir dicho material debe obtenerse de los correspondientes titulares de derechos.
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'; font-weight:bold">
        16
      </span>
      <span style="font:7pt 'Times New Roman'">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <span style="font-family:'Times New Roman'; font-weight:bold">
        Rescisión del Acuerdo
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        Usted tiene derecho a rescindir el presente Acuerdo en cualquier momento notificándonos por escrito con un mes de antelación indicando que no desea seguir utilizando los servicios de la plataforma correspondiente.
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        Nuestra cuenta de correo electrónico de contacto es ‘contact@air-class.com’
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:14pt">
      <span style="font-family:'Times New Roman'">
        &nbsp;
      </span>
    </p>
    <p style="margin-top:0pt; margin-bottom:0pt; text-align:right; widows:0; orphans:0; font-size:14pt">
      <span style="font-family:'Baskerville Old Face'">
        AirClass
      </span>
      <span style="font-family:'Baskerville Old Face'">
        Limited
      </span>
    </p>
    <div style="-aw-headerfooter-type:footer-primary">
      <div style="-aw-sdt-tag:''">
        <p style="margin-top:0pt; margin-bottom:0pt; text-align:right; widows:0; orphans:0; font-size:9pt">
          <span style="-aw-field-start:true">
          </span>
          <span style="-aw-field-code:' PAGE   \\\\* MERGEFORMAT '">
          </span>
          <span style="-aw-field-separator:true">
          </span>
          <span style="font-family:'等线'">
          </span>
          <span style="-aw-field-end:true">
          </span>
        </p>
      </div>
      <p style="margin-top:0pt; margin-bottom:0pt; widows:0; orphans:0; font-size:9pt">
        <span style="font-family:'等线'">
          &nbsp;
        </span>
      </p>
    </div>
  `
}
